import * as actionTypes from "../../actions/exportCsv/actionTypes";
import { updateObject } from "../../utility/utility";

const initialState = {
  exportError: [],
  exportLoading: false,
  exportFrontUserList: [],
  exportRePaymentDistributionList: [],
  exportDistributionViewList: [],
  exportRePaymentReceivedList: [],
  exportSavedInvestmentList: [],
  exportTransactionsList: [],
};

const exportingStart = (state, action) => {
  return updateObject(state, {
    exportLoading: true,
    exportError: [],
    exportFrontUserList: [],
    exportRePaymentDistributionList: [],
    exportDistributionViewList: [],
    exportRePaymentReceivedList: [],
    exportSavedInvestmentList: [],
    exportTransactionsList: [],
  });
};

const exportCSVFail = (state, action) => {
  return updateObject(state, {
    exportError: action.error,
    exportLoading: false,
  });
};

const getFrontUserCSVListSuccess = (state, action) => {
  return updateObject(state, {
    exportLoading: false,
    exportError: [],
    exportFrontUserList: action.response,
  });
};

const getRePaymentDistributionListSuccess = (state, action) => {
  return updateObject(state, {
    exportLoading: false,
    exportError: [],
    exportRePaymentDistributionList: action.response,
  });
};

const getDistributionViewCSVListSuccess = (state, action) => {
  return updateObject(state, {
    exportLoading: false,
    exportError: [],
    exportDistributionViewList: action.response,
  });
};

const getRePaymentReceivedCSVListSuccess = (state, action) => {
  return updateObject(state, {
    exportLoading: false,
    exportError: [],
    exportRePaymentReceivedList: action.response,
  });
};

const getSavedInvestmentCSVListSuccess = (state, action) => {
  return updateObject(state, {
    exportLoading: false,
    exportError: [],
    exportSavedInvestmentList: action?.response?.data?.message?.docs,
  });
};

const getTransactionsCSVListSuccess = (state, action) => {
  return updateObject(state, {
    exportLoading: false,
    exportError: [],
    exportTransactionsList: action.response,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.EXPORT_CSV_START:
      return exportingStart(state, action);
    case actionTypes.EXPORT_CSV_COMMON_ERROR:
      return exportCSVFail(state, action);
    case actionTypes.EXPORT_CSV_FRONT_USERS_SUCCESS:
      return getFrontUserCSVListSuccess(state, action);
    case actionTypes.GET_SAVED_INVESTMENT_CSV_LIST_SUCCESS:
      return getSavedInvestmentCSVListSuccess(state, action);
    case actionTypes.GET_REPAYMENT_DISTRIBUTION_CSV_LIST_SUCCESS:
      return getRePaymentDistributionListSuccess(state, action);
    case actionTypes.GET_DISTRIBUTION_VIEW_CSV_LIST_SUCCESS:
      return getDistributionViewCSVListSuccess(state, action);
    case actionTypes.GET_REPAYMENT_RECEIVED_CSV_LIST_SUCCESS:
      return getRePaymentReceivedCSVListSuccess(state, action);
    case actionTypes.EXPORT_CSV_TRANSACTIONS_SUCCESS:
      return getTransactionsCSVListSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
